module.exports = __webpack_public_path__ + "static/media/28_CALCINHA_TRADICIONAL_ESTAMPADA_02.08c3b287.jpg";